import { AdditionalQuestion } from '@/types/guest';

export interface GuestApiPayload {
  id: string;
  name: string;
  surname: string;
  presence?: boolean | undefined;
  connection: string;
  connectedGuestId: string;
  additionalQuestions: AdditionalQuestion[];
  tableNumber?: number | undefined;
  tableLayoutInfo?: unknown;
  tableAdditionalInfo?: string | undefined;
  seatIndex?: number | undefined;
}

type GuestLike = {
  id: string;
  name: string;
  surname: string;
  presence?: boolean | undefined;
  connection: string;
  connectedGuestId: string;
  additionalQuestions: AdditionalQuestion[];
  tableNumber?: number | undefined;
  tableLayoutInfo?: unknown;
  tableAdditionalInfo?: string | undefined;
  seatIndex?: number | undefined;
};

export const guestToApiPayload = (guest: GuestLike): GuestApiPayload => ({
  id: guest.id,
  name: guest.name,
  surname: guest.surname,
  presence: guest.presence,
  connection: guest.connection,
  connectedGuestId: guest.connectedGuestId,
  additionalQuestions: guest.additionalQuestions,
  tableNumber: guest.tableNumber,
  tableLayoutInfo: guest.tableLayoutInfo,
  tableAdditionalInfo: guest.tableAdditionalInfo,
  seatIndex: guest.seatIndex,
});

export const parseGuestFromApi = (guest: Record<string, unknown>): GuestApiPayload => {
  const additionalQuestionsRaw = guest['additionalQuestions'];
  let additionalQuestions: AdditionalQuestion[] = [];

  if (typeof additionalQuestionsRaw === 'string') {
    try {
      additionalQuestions = JSON.parse(additionalQuestionsRaw) as AdditionalQuestion[];
    } catch {
      additionalQuestions = [];
    }
  } else if (Array.isArray(additionalQuestionsRaw)) {
    additionalQuestions = additionalQuestionsRaw as AdditionalQuestion[];
  }

  return {
    id: String(guest['id'] ?? ''),
    name: String(guest['name'] ?? ''),
    surname: String(guest['surname'] ?? ''),
    presence: guest['presence'] === undefined ? undefined : Boolean(guest['presence']),
    connection: String(guest['connection'] ?? ''),
    connectedGuestId: String(guest['connectedGuestId'] ?? ''),
    additionalQuestions,
    tableNumber: guest['tableNumber'] !== undefined ? Number(guest['tableNumber']) : undefined,
    tableLayoutInfo: guest['tableLayoutInfo'],
    tableAdditionalInfo: guest['tableAdditionalInfo'] !== undefined ? String(guest['tableAdditionalInfo']) : undefined,
    seatIndex: guest['seatIndex'] !== undefined ? Number(guest['seatIndex']) : undefined,
  };
};
